import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2f428dde"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "editable-input" }
const _hoisted_2 = ["value"]

import { computed, PropType } from 'vue'
import tinycolor, { ColorFormats } from 'tinycolor2'


export default /*#__PURE__*/_defineComponent({
  __name: 'EditableInput',
  props: {
  value: {
    type: Object as PropType<ColorFormats.RGBA>,
    required: true,
  },
},
  emits: ["colorChange"],
  setup(__props, { emit }: { emit: ({
  (event: 'colorChange', payload: ColorFormats.RGBA): void
}), expose: any, slots: any, attrs: any }) {

const props = __props;





const val = computed(() => {
  let _hex = ''
  if (props.value.a < 1) _hex = tinycolor(props.value).toHex8String().toUpperCase()
  else _hex = tinycolor(props.value).toHexString().toUpperCase()
  return _hex.replace('#', '')
})

const handleInput = (e: Event) => {
  const value = (e.target as HTMLInputElement).value
  if (value.length >= 6) emit('colorChange', tinycolor(value).toRgb())
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("input", {
      class: "input-content",
      value: _unref(val),
      onInput: _cache[0] || (_cache[0] = $event => handleInput($event))
    }, null, 40, _hoisted_2)
  ]))
}
}

})